import { Box, ThemeContext } from 'grommet';
import React, { useContext, useState } from 'react';
import { faPencil as IconEdit} from '@fortawesome/pro-light-svg-icons';
import CustomerTag from './CustomerTag';
import Button from './Button';
import FontAwesomeIcon from './FontAwesomeIcon';
import ChangeCustomerModal from './pages/transactions/ChangeCustomerModal';
import { DarkenOnHoverBox } from '../utils/styled';

const EditableCustomerTag = ({
    customerId,
    transactionId,
    editable = false,
    onSuccess,
    inline = false
}) => {
    const theme = useContext(ThemeContext);
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Box direction="row" align="center">
                <CustomerTag id={customerId} inline={inline} />
                {editable && (
                    <Button
                        plain
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowModal(true);
                        }}
                        tip="Change customer"
                        label={
                            <DarkenOnHoverBox
                                background={theme.dark ? "foreground" : "light-1"}
                                border={[
                                    { side: 'top', color: 'border' },
                                    { side: 'right', color: 'border' },
                                    { side: 'bottom', color: 'border' }
                                ]}
                                round="xxsmall"
                                pad={{ horizontal: 'xsmall', vertical: 'xsmall' }}
                                margin={{ left: '-1px' }}
                                theme={theme}
                            >
                                <FontAwesomeIcon SelectedIcon={IconEdit} size="xsmall" color="text-weak" />
                            </DarkenOnHoverBox>
                        }
                    />
                )}
            </Box>
            {showModal && (
                <ChangeCustomerModal
                    transactionId={transactionId}
                    currentCustomerId={customerId}
                    onClose={() => setShowModal(false)}
                    onSuccess={() => {
                        setShowModal(false);
                        onSuccess && onSuccess();
                    }}
                />
            )}
        </>
    );
};

export default EditableCustomerTag;
